import { Box, Drawer, Stack, SvgIcon, Typography } from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { MailText, MailTextGroup } from '@/models/mailConfiguration';
import IconButton from '@mui/material/IconButton';
import XCircleIcon from '@heroicons/react/24/solid/XMarkIcon';
import {
    mailTextConfig,
    MailTextConfigKey,
} from '@/pages/mailConfiguration/components/mailTexts/mailTextConfig';
import { MailTextBlock } from '@/pages/mailConfiguration/components/mailTexts/MailTextBlock';

type MailTextsProps = {
    initialMailTexts: MailText;
    onMailTextsUpdate: (newMailText: MailText) => void;
};

export const MailTexts: FunctionComponent<MailTextsProps> = ({
    initialMailTexts,
    onMailTextsUpdate,
}) => {
    const [showMailTemplate, setShowMailTemplate] =
        useState<MailTextConfigKey>(null);
    const onGroupUpdate = (newGroup: MailTextGroup) => {
        const groupsToUpdate = [...initialMailTexts.groups];

        const initialGroupIndex = groupsToUpdate.findIndex(
            (group) => group.name === newGroup.name
        );

        if (initialGroupIndex > -1) {
            groupsToUpdate[initialGroupIndex] = newGroup;

            onMailTextsUpdate({
                ...initialMailTexts,
                groups: groupsToUpdate,
            });
        }
    };

    const sortedMailTexts = {
        ...initialMailTexts,
        groups: [...initialMailTexts.groups].sort(
            (groupA, groupB) =>
                mailTextConfig[groupA.name]?.sort -
                mailTextConfig[groupB.name]?.sort
        ),
    };

    return (
        <Stack spacing={3}>
            <Box>
                <Typography gutterBottom>
                    Platzieren Sie gezielt die Infos, die Ihren Gästen für den
                    Besuch in Ihrer Destination hilfreich sind. Sie können alle
                    im PDF farbig markierten Textpassagen überschreiben. Wenn
                    Sie ein Textfeld nicht befüllen, wird der angegebene
                    Standardtext verwendet.
                </Typography>
                <Typography>
                    Tipp: Jahreszeiten-neutrales wording verwenden, wenn Tickets
                    ganzjährig angeboten werden! ( z.B. „Skiticket“ ist nicht
                    ganzjährig passend)
                </Typography>
            </Box>

            <Stack spacing={2}>
                {sortedMailTexts?.groups.map((group, index) => (
                    <MailTextBlock
                        key={index}
                        onShowImage={(image) => setShowMailTemplate(image)}
                        group={group}
                        onGroupUpdate={onGroupUpdate}
                    />
                ))}
            </Stack>

            <Drawer
                anchor={'right'}
                open={!!showMailTemplate}
                onClose={() => setShowMailTemplate(null)}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        p: 3,
                    }}
                >
                    <IconButton onClick={() => setShowMailTemplate(null)}>
                        <SvgIcon fontSize={'large'}>
                            <XCircleIcon />
                        </SvgIcon>
                    </IconButton>
                </Box>
                {showMailTemplate && (
                    <img
                        src={mailTextConfig[showMailTemplate]?.image}
                        style={{
                            width: 800,
                            height: 'auto',
                        }}
                    />
                )}
            </Drawer>
        </Stack>
    );
};
